// The DRA's own JS errors -> pm-errors-api, the store + dashboard pm-motors-plugin's
// js-error-tracker.js already feeds (error.dev.pixelmotiondemo.com, one list per siteToken).
//
// Unlike the plugin's tracker it never replaces window.onerror, console.error or XHR, and it
// drops whatever isn't ours: on a third-party site (Dealer.com...) most errors on the page are
// the host's. Only errors whose file/stack points at our scripts are sent, plus what our code
// reports itself (window.PMDRA_ERROR_TRACKER.report, e.g. RequestHelper's failed API calls).
//
// Gated: only pmdra-ddc.js and pmdra-dinspire.js start it for now (gulp copy-external-script inlines this file
// there, like PaymentDisclosures.js). Keep it dependency-free: no imports, plain functions.
// Nothing is persisted (no cookie/storage): consent tools block scripts that store ids.

const ERROR_TRACKER_URL = "https://error.dev.pixelmotiondemo.com/api/jsErrorLog";
const ERROR_TRACKER_MAX_PER_PAGE = 10;

// opts: { integration: "ddc", ownScripts: [url fragments that identify our files],
//         getSiteToken: () => resolved siteToken or null }
export function startErrorTracker(opts) {
    if (window.PMDRA_ERROR_TRACKER) return window.PMDRA_ERROR_TRACKER;
    // bots/automation: noise, same skip as the plugin's tracker
    if (navigator.webdriver || /bot|crawl|spider|slurp|headless|lighthouse/i.test(navigator.userAgent)) return null;

    const sessionId = Date.now().toString(36) + Math.random().toString(36).slice(2, 9); // this page view only
    const seen = {};
    let sent = 0;
    const isOurs = (text) => !!text && opts.ownScripts.some((s) => String(text).indexOf(s) !== -1);

    function report(type, message, extra) {
        message = String(message || "").slice(0, 1000);
        const key = type + "|" + message;
        if (seen[key] || sent >= ERROR_TRACKER_MAX_PER_PAGE) return;
        seen[key] = true;
        sent++;
        const payload = Object.assign({
            type: type,
            message: message,
            source: null,
            lineno: null,
            colno: null,
            error: null,
        }, extra || {}, {
            // unresolved dealer (or the resolver failed): still visible on the dashboard, by host
            siteToken: opts.getSiteToken() || "unresolved:" + location.hostname,
            integration: opts.integration,
            url: location.href,
            userAgent: navigator.userAgent,
            sessionId: sessionId,
            timestamp: new Date().toISOString(),
            screenSize: screen.width + "x" + screen.height,
            viewport: innerWidth + "x" + innerHeight,
            referrer: document.referrer || null,
        });
        try {
            fetch(ERROR_TRACKER_URL, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
                credentials: "omit",
                keepalive: true,
            }).catch(() => {});
        } catch (e) { /* never let the tracker throw */ }
    }

    // runtime errors thrown from our files (not resource load errors: those don't bubble)
    window.addEventListener("error", (ev) => {
        const stack = ev.error && ev.error.stack;
        if (!isOurs(ev.filename) && !isOurs(stack)) return;
        report("error", ev.message, { source: ev.filename || null, lineno: ev.lineno || null, colno: ev.colno || null, error: stack || null });
    });
    window.addEventListener("unhandledrejection", (ev) => {
        const reason = ev.reason;
        const stack = reason && reason.stack;
        if (!isOurs(stack)) return;
        report("promiseRejection", (reason && reason.message) || String(reason), { error: stack });
    });

    return (window.PMDRA_ERROR_TRACKER = { report: report, sessionId: sessionId });
}

// For code that caught an error itself: sends it if a tracker is running, no-op otherwise.
export function reportError(type, error, extra) {
    const tracker = window.PMDRA_ERROR_TRACKER;
    if (!tracker) return;
    tracker.report(type, error && error.message ? error.message : String(error), Object.assign({ error: (error && error.stack) || null }, extra || {}));
}
